(function () {
  'use strict';

  function initializeNonConfigurableBundlePage(root) {
    if (root.hasAttribute('data-ncvb-initialized')) return;
    root.setAttribute('data-ncvb-initialized', 'true');

    var state = {
      category: 'all',
      query: ''
    };
    var searchInput = root.querySelector('[data-ncvb-search]');
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ncvb-filter]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-ncvb-section]'));
    var noResults = root.querySelector('[data-ncvb-no-results]');

    sections.forEach(function (section) {
      var categoryName = section.getAttribute('data-ncvb-category-name') || '';

      section.querySelectorAll('[data-ncvb-card]').forEach(function (card) {
        var title = card.querySelector('.non-configurable-bundle-card__title');
        var features = card.querySelector('.non-configurable-bundle-card__features');

        card.setAttribute(
          'data-ncvb-search-value',
          normalizeSearchText([
            categoryName,
            title ? title.textContent : '',
            features ? features.textContent : ''
          ].join(' '))
        );
      });
    });

    root.addEventListener('click', function (event) {
      var filterButton = event.target.closest('[data-ncvb-filter]');

      if (filterButton && root.contains(filterButton)) {
        event.preventDefault();
        state.category = filterButton.getAttribute('data-ncvb-filter') || 'all';

        filterButtons.forEach(function (button) {
          var isActive = button === filterButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        applyFilters(sections, noResults, state);
        return;
      }

      var actionButton = event.target.closest('[data-ncvb-action]');
      if (!actionButton || !root.contains(actionButton) || actionButton.disabled) return;

      event.preventDefault();
      addFixedBundle(actionButton);
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.query = normalizeSearchText(searchInput.value);
        applyFilters(sections, noResults, state);
      });
    }

    applyFilters(sections, noResults, state);
  }

  async function addFixedBundle(button) {
    var purchase = button.closest('[data-ncvb-purchase]');
    if (!purchase) return;

    var status = purchase.querySelector('[data-ncvb-status]');
    var originalText = button.textContent;
    var action = button.getAttribute('data-ncvb-action');
    var shouldCheckout = action === 'buy-now';
    var items = [];

    try {
      items = JSON.parse(purchase.getAttribute('data-ncvb-items') || '[]');
    } catch (error) {
      showError(status, 'This bundle could not be prepared. Please refresh the page and try again.');
      return;
    }

    items = items.filter(function (item) {
      return item && item.id && item.quantity > 0;
    });

    if (!items.length) {
      showError(status, 'This bundle is not currently available.');
      return;
    }

    var actionButtons = Array.prototype.slice.call(purchase.querySelectorAll('[data-ncvb-action]'));
    var previousDisabledStates = actionButtons.map(function (actionButton) {
      var wasDisabled = actionButton.disabled;
      actionButton.disabled = true;
      return wasDisabled;
    });

    button.textContent = shouldCheckout ? 'Preparing checkout...' : 'Adding...';
    clearStatus(status);

    try {
      var discountCode = (purchase.getAttribute('data-ncvb-discount-code') || '').trim();

      if (discountCode) {
        var discountResponse = await fetch(
          shopifyRoot() + 'discount/' + encodeURIComponent(discountCode),
          { credentials: 'same-origin' }
        );

        if (!discountResponse.ok) {
          throw new Error('The bundle discount could not be applied.');
        }
      }

      var response = await fetch(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      var result = await response.json();

      if (!response.ok || (result && result.status && result.status >= 400)) {
        throw new Error(
          (result && (result.description || result.message)) ||
            'This bundle could not be added to your cart.'
        );
      }

      if (shouldCheckout) {
        if (status) status.textContent = 'Redirecting to checkout...';
        window.location.assign(shopifyRoot() + 'checkout');
        return;
      }

      if (status) status.textContent = 'Added to your cart.';
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (error) {
      showError(status, error.message || 'This bundle could not be added to your cart.');
    } finally {
      button.textContent = originalText;
      actionButtons.forEach(function (actionButton, index) {
        actionButton.disabled = previousDisabledStates[index];
      });
    }
  }

  function applyFilters(sections, noResults, state) {
    var visibleBundleCount = 0;

    sections.forEach(function (section) {
      var sectionCategory = section.getAttribute('data-ncvb-category') || '';
      var categoryMatches = state.category === 'all' || state.category === sectionCategory;
      var visibleInSection = 0;

      section.querySelectorAll('[data-ncvb-card]').forEach(function (card) {
        var searchValue = card.getAttribute('data-ncvb-search-value') || '';
        var searchMatches = !state.query || searchValue.indexOf(state.query) !== -1;
        var isVisible = categoryMatches && searchMatches;

        card.hidden = !isVisible;
        if (isVisible) visibleInSection += 1;
      });

      section.hidden = visibleInSection === 0;
      visibleBundleCount += visibleInSection;
    });

    if (noResults) noResults.hidden = visibleBundleCount !== 0;
  }

  function normalizeSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function clearStatus(status) {
    if (!status) return;
    status.textContent = '';
    status.removeAttribute('data-error');
  }

  function showError(status, message) {
    if (!status) return;
    status.textContent = message;
    status.setAttribute('data-error', 'true');
  }

  function initializeAll() {
    document.querySelectorAll('[data-ncvb-root]').forEach(initializeNonConfigurableBundlePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
})();
